export default {
  thumbnail: {
    margin: [0, -12, 20],
    backgroundColor: '#c7c7c7',
    width: 'calc(100% + 24px)',
    display: 'block',
  },
};
